import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import useMmcService from "../../services/MmcService";
import InitContext from "../pages/InitContext";
import {Consts} from "../pages/consts";

const SymptomImages = ({
  symptom,
  onDeleteImage,
  onAddImages,
  printView = false
}) => {
  const { t: t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [thumbnailUrls, setThumbnailUrls] = useState({});
  const context = useContext(InitContext);
  const { getDbSymptomImage } = useMmcService();

  const loadThumbnailUrls = async () => {
    const urls = {};

    if (symptom?.images) {
      //const images = await getDbSymptomImages(context?.token, symptom?.id);
      for (const image of symptom?.images) {
        urls[image?.id] = await getThumbnailUrl(image?.id);
      }
    }

    setThumbnailUrls(urls);
  };

  useEffect(() => {
    loadThumbnailUrls().then();
  }, [symptom?.images]);

  const handleThumbnailClick = async (imageId) => {
    const result = await getDbSymptomImage(context?.token, imageId?.id);

    if (result) {
      const { blob } = result;
      const url = window.URL.createObjectURL(blob);
      setSelectedImage(url);
    }
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const getThumbnailUrl = async (imageId) => {
    const result = await getDbSymptomImage(context?.token, imageId);

    if (result) {
      const { blob } = result;
      return window.URL.createObjectURL(blob);
    }
  };

  const handleAddImages = (event) => {
    const newFiles = Array.from(event.target.files);
    onAddImages(symptom, newFiles);
  };

  return (
    <>
      <div className="w3-row w3-padding-small">
        <label>{t("images")}:</label>
      </div>
      <div className="w3-row">
        {symptom?.images?.map((image, index) => (
          <div key={index} className="w3-col s2 w3-border w3-margin-left">
            {!printView && (
              <FontAwesomeIcon
                icon={faXmark}
                onClick={() => onDeleteImage(symptom?.id, image?.id)}
                className="w3-right label-link"
              />
            )}
            <img
              key={index}
              src={thumbnailUrls[image?.id]}
              alt={image?.file_name}
              className="w3-image w3-hover-opacity thumbnail"
              onClick={() => handleThumbnailClick(image)}
            />
          </div>
        ))}
        {!printView && (
          <div
            className={
              symptom?.images?.length > 0 ? "w3-col s2 w3-margin-left" : ""
            }
          >
            <input
              id={`symptom-images-upload-${symptom?.id}`}
              type="file"
              accept="image/*"
              multiple
              onChange={handleAddImages}
              style={{ display: Consts.NONE }}
            />
            <label
              htmlFor={`symptom-images-upload-${symptom?.id}`}
              className="w3-btn w3-round-xlarge w3-theme-d5 responsive-button"
            >
              {t("add_related_images")} ({t("if_applicable")})
            </label>
          </div>
        )}
      </div>
      {selectedImage && (
        <div className="image-fullscreen-container" onClick={handleCloseModal}>
          <img
            src={selectedImage}
            alt="Symptom image"
            className="image-fullscreen"
          />
          <div className="image-fullscreen-close">
            <label>{t("click_to_close")}</label>
          </div>
        </div>
      )}
      {symptom?.images?.length > 0 && !printView && (
        <div className="w3-row w3-margin-left w3-center">
          <label>{t("click_on_thumbnail_to_enlarge")}</label>
        </div>
      )}
    </>
  );
};

export default SymptomImages;
